// v14ao-fix — Canonical adres formatter voor AutoMeasure.
//
// Client/Project adressen worden in de database bewaard als multi-line strings
// zoals "Mollenveldwijk 11\n3271 Scherpenheuvel-Zichem". Wanneer deze zonder
// normalisatie als single-line input gebruikt worden, valt de newline weg en
// ontstaat de malformed variant "Mollenveldwijk 113271 Scherpenheuvel-Zichem".
//
// Deze helper produceert de canonical single-line vorm die AutoMeasure kan
// resolven:  "Straat + huisnr, postcode + gemeente"
//
// Gebruik op ELKE entry-path:
//   - defaultAddress in AutoMeasureZoneBlock (project/client raw string)
//   - initiële prefill in "Adres wijzigen" dialog
//   - handmatig ingevoerde user-input (indien de user newlines plakt)
//   - "Opnieuw meten" (leest opgeslagen measurement_address, doorgaans al
//     canonical dankzij backend response, maar we blijven defensief)

export function canonicalizeAddress(raw) {
  if (raw == null) return "";
  const s = String(raw);
  if (!s.trim()) return "";
  // Splits op newlines (inclusief \r\n), semicolons of pipes.
  const parts = s
    .split(/[\r\n;|]+/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length <= 1) {
    // Enkel-line input: return as-is (kan al canonical zijn zoals
    // "Mollenveldwijk 11, 3271 Scherpenheuvel-Zichem").
    return parts[0] || s.trim();
  }
  // Meer dan één lijn → join met ", ". Behoud interne komma's onaangeroerd.
  return parts.join(", ");
}
